/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportAppMessageView} from '../api'

export const useMutationReportAppMessageView = createReactQueryMutationHook('reportAppMessageView', reportAppMessageView)
